import { DEV_BYPASS_AUTH } from "@/lib/auth-config";

export function DevBanner() {
  if (!DEV_BYPASS_AUTH) return null;
  return (
    <div
      data-testid="dev-banner"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        width: "100%",
        padding: "6px 0",
        background: "color-mix(in oklab, var(--qv3-gold) 12%, transparent)",
        borderBottom: "0.5px solid var(--qv3-gold)",
        textAlign: "center",
        fontFamily: "var(--qv3-font-mono)",
        fontSize: 10,
        textTransform: "uppercase",
        letterSpacing: 3,
        color: "var(--qv3-led-red)",
      }}
    >
      MODE DÉVELOPPEMENT · AUTH DÉSACTIVÉE · BYPASS ACTIF
    </div>
  );
}
